import { Button } from "react-bootstrap";

import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const RefreshButton = ({
	onClick,
	isSpin = false,
}: {
	onClick(): any;
	isSpin?: boolean;
}) => (
	<Button
		onClick={onClick}
		key="btn-refresh"
		variant="outline-primary"
		size="sm"
		disabled={isSpin}
	>
		<FontAwesomeIcon className={isSpin ? "fa-spin" : ""} icon={faRefresh} />
	</Button>
);
